export const ASIDE_PANEL_DEFAULT_WIDTH = 400;
export const ASIDE_PANEL_MIN_WIDTH = 400;
export const ASIDE_PANEL_MAX_WIDTH_RATIO = 0.5;
export const ASIDE_PANEL_WIDTH_STORAGE_KEY = "ottopilot-aside-panel-width";

export function computeAsidePanelMaxWidth(containerWidth: number): number {
    return Math.max(ASIDE_PANEL_MIN_WIDTH, Math.floor(containerWidth * ASIDE_PANEL_MAX_WIDTH_RATIO));
}

export function clampAsidePanelWidth(width: number, containerWidth: number): number {
    const maxWidth = computeAsidePanelMaxWidth(containerWidth);
    return Math.min(maxWidth, Math.max(ASIDE_PANEL_MIN_WIDTH, width));
}

export function readStoredAsidePanelWidth(): number {
    if (typeof window === "undefined") {
        return ASIDE_PANEL_DEFAULT_WIDTH;
    }

    try {
        const raw = localStorage.getItem(ASIDE_PANEL_WIDTH_STORAGE_KEY);
        if (raw === null) {
            return ASIDE_PANEL_DEFAULT_WIDTH;
        }

        const parsed = Number.parseInt(raw, 10);
        if (Number.isFinite(parsed) !== true) {
            return ASIDE_PANEL_DEFAULT_WIDTH;
        }

        return Math.max(ASIDE_PANEL_MIN_WIDTH, parsed);
    } catch {
        return ASIDE_PANEL_DEFAULT_WIDTH;
    }
}

export function persistAsidePanelWidth(width: number): void {
    if (typeof window === "undefined") {
        return;
    }

    try {
        localStorage.setItem(ASIDE_PANEL_WIDTH_STORAGE_KEY, String(width));
    } catch {
        // ignore quota / private mode errors
    }
}
